import React, { Fragment, useEffect, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";

import { ChevronDown, ChevronUp, User, MapPin, Phone } from "lucide-react";
import PayIcon from "../../assets/icons/address-bar/pay-icon";
import ShipIcon from "../../assets/icons/address-bar/ship-icon";
import AddButton from "../buttons/button";
import { useDispatch } from "react-redux";
import { getAddress, valListAction } from "../../redux/actions/general-action";
import PersonIcon from "../../assets/icons/address-bar/person-icon";
import AddressIcon from "../../assets/icons/address-bar/address-icon";
import CallIcon from "../../assets/icons/address-bar/address-icon";
import NameIcon from "../../assets/icons/address-bar/name-icon";
import AddressTitleIcon from "../../assets/icons/address-bar/address-title-icon";
import errorToast from "../helper-components/error-toast";
import { useFormikContext } from "formik";
import AdminAddCustomer from "../../modules/customer-admin/add-customer";
import { useNavigate } from "react-router-dom";
import AdminEditCustomer from "../../modules/customer-admin/edit-customer";
import successToast from "../helper-components/success-toast";
import LoadingOverlay from "../helper-components/overlay-loading";

const AddressSidebarSales = ({
  isClone = false,
  type,
  open,
  setOpen,
  id,
  pos_id,
  disabled = false,
  name,
  pageType,
  page,
  clickedplus = false,
  autoDraft,
  storeState,
  transfer=false,
  standAlone = true,
}) => {
  const [openSectionPay, setOpenSectionPay] = useState(null);
  const [openSectionShip, setOpenSectionShip] = useState(null);
  const [noAddress, setNoAddress] = useState(false);
  const [invert, setInvert] = useState(false);
  const [loading, setLoading] = useState(false);

  const [payList, setPayList] = useState([]);
  const [shipList, setShipList] = useState([]);
  const [savedPay, setSavedPay] = useState({});
  const [block, setBlock] = useState(false);
  const [noList, setNoList] = useState(false);

  const [savedShip, setSavedShip] = useState({});
  const { values, setFieldValue } = useFormikContext();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  console.log("900", id);
  console.log("800", block, name, page, pageType);
  let prefix = name;
  useEffect(() => {
    if (
      pageType === "sales return" ||
      pageType === "purchase return" ||
      pageType === "credit note" ||
      pageType === "purchase credit"
    ) {
      setInvert(true);
    }
  }, [pageType]);
  useEffect(() => {
    console.log(
      "clicked ==================",
      !clickedplus || !isClone,
      clickedplus
    );
    if (!clickedplus && !isClone) {
      if (
        pageType === "sales return" ||
        pageType === "credit note" ||
        pageType === "purchase invoice" ||
        pageType === "purchase return" ||
        pageType === "purchase credit" ||
        pageType === "invoice"
      ) {
        // In edit mode, allow address editing; in view mode, block it
        setBlock(page === "view");
      } else {
        // For add-purchase/[]/purchase?new, always allow Add Address (no items required)
        if (page === "add" && pageType === "purchase") {
          setBlock(false);
        } else {
          setBlock(disabled);
        }
      }
    }
  }, [disabled, type, page, pageType]);
  // useEffect(() => {
  //   if (noList) {
  //     setNoAddress(false);
  //   }
  // }, [noList]);
  const onSuccess = (data) => {
    console.log(":::::", data);
    const shipping = data?.data?.addressShipping || [];
    const pay = data?.data?.addressPay || [];
    console.log("::", shipping);
    // Always expose the full master list so the user can pick another address.
    setShipList(shipping);
    setPayList(pay);

    // The address flagged as default (falling back to the first one) is used as
    // the pre-selected value whenever the document hasn't saved its own address.
    const defaultShip =
      shipping.find((a) => a?.cmr_default_address) || shipping[0] || null;
    const defaultPay = pay.find((a) => a?.cmr_default_address) || pay[0] || null;
    const defaultShipId = defaultShip?.cmr_ship_address_id ?? null;
    const defaultPayId = defaultPay?.cmr_pay_address_id ?? null;
    if(transfer){
      let payto = values[`${name}_pay_to_address`];
      let shipto = values[`${name}_ship_to_address`];
      setShipList(shipto ? [shipto] : []);
      setPayList(payto ? [payto] : []);
      setOpenSectionShip(shipto?.cmr_ship_address_id ?? null);
      setOpenSectionPay(payto?.cmr_pay_address_id ?? null);
      const address_state=shipto?.cmr_ship_address_state?.toLowerCase() || null;
      const store_state=storeState?.toLowerCase()?.trim();
      if(!address_state){
        errorToast("Please set ship to address state");
        return;
      }
      if(store_state===null || store_state===undefined || store_state?.trim()===""){
        //errorToast("Please set store state");
        return;
      }
      if(store_state===address_state){
        setFieldValue("is_inter_state",false);
      }else{
        setFieldValue("is_inter_state",true);
      }
    } else if (
      page === "add" &&
      !isClone &&
      (pageType == "sales" || pageType === "purchase" || clickedplus)
      // (pageType === "purchase return" && page === "edit" && clickedplus)
    ) {
      setOpenSectionShip(defaultShipId);
      setOpenSectionPay(defaultPayId);
    } else {
      console.log(
        "view billing",
        values,
        name,
        values[`${name}_pay_to_address`]
      );
      let payto = values[`${name}_pay_to_address`];
      let shipto = values[`${name}_ship_to_address`];

      if (
        !isClone &&
        (page === "view" ||
          pageType === "credit note" ||
          pageType === "sales return" ||
          pageType === "purchase invoice" ||
          pageType === "purchase credit" ||
          pageType === "purchase return") &&
        !(pageType === "purchase return" && page === "edit" && clickedplus) &&
        !(pageType === "purchase credit" && page === "edit" && clickedplus) &&
        !(pageType === "grn" && page === "edit" && clickedplus) &&
        !(pageType === "purchase invoice" && page === "edit" && clickedplus) &&
        !(pageType === "invoice" && page === "edit" && clickedplus) &&
        !(pageType === "delivary" && page === "edit" && clickedplus) &&
        !(pageType === "credit note" && page === "edit") &&
        !(pageType === "sales return" && page === "edit")
      ) {
        // Show the address saved on the document. When the document is missing
        // one side (e.g. only a ship-to), fall back to the default from the
        // master list so it is still shown instead of "No Address".
        const shipShown = shipto || defaultShip;
        const payShown = payto || defaultPay;
        if (!shipShown && !payShown) {
          setNoAddress(true);
        } else {
          setNoList(true);
          setNoAddress(false);
          setShipList(shipShown ? [shipShown] : []);
          setPayList(payShown ? [payShown] : []);
        }
      }

      // else if (page === "edit" && (payto === null || shipto === null)) {
      //   setOpenSectionShip(data?.data?.addressShipping[0].cmr_ship_address_id);
      //   setOpenSectionPay(data?.data?.addressPay[0].cmr_pay_address_id);
      // } else {

      console.log("payto", payto?.cmr_pay_address_id);
      console.log("shipto", shipto?.cmr_ship_address_id);
      // Pre-select the document's saved address; otherwise fall back to the
      // default address returned by the API.
      setOpenSectionShip(shipto?.cmr_ship_address_id ?? defaultShipId);
      setOpenSectionPay(payto?.cmr_pay_address_id ?? defaultPayId);
      // }
    }
  };
  console.log("iscloneeeeeeeeeeeee", isClone);
  const onError = (data) => {
    // errorToast("could not fetch address");
  };
  // useEffect(() => {
  //   if (page !== "add") {
  //     let payto = values[`${name}_pay_to_address`];
  //     let shipto = values[`${name}_ship_to_address`];
  //     console.log(payto, shipto);
  //     if (payto && payto.cmr_pay_address_id) {
  //       console.log("payto", payto, typeof payto, payto && Object.keys(payto));

  //       setOpenSectionShip(payto.cmr_pay_address_id);
  //       setOpenSectionPay(shipto.cmr_ship_address_id);
  //     }
  //   }
  // }, [values]);
  useEffect(() => {
    // if (page !== "add") {
    //   console.log("payto", payto);
    //   setPayList(payto);
    //   setShipList(shipto);
    // }
    // console.log("99", values.cmr_id);
    // let finalId = id;
    // if (page !== "add") finalId = values.cmr_id;
    // console.log("finalId", finalId);
    if (type === "return") {
      console.log(
        "retuuuuuuuuuuurn",
        type === "return",
        values.icn_ship_from_address,
        values.icn_ship_from_address !== null
      );
      if (values.icn_ship_from_address) {
        setOpenSectionShip(values.icn_ship_from_address);
      } else {
        setNoAddress(true);
      }
    } else {
      dispatch(getAddress({cmr_id:id,pos_id:pos_id}, onSuccess, onError));
    }
  }, [id,storeState]);

  const AddressCard = ({ address, onClose }) => (
    <div className="bg-[var(--address-open-bg)] border-2 border-[var(--address-open-border-color)] rounded-lg py-5 pl-5 pr-[10px] flex flex-col gap-5">
      {/* <FetchAddress
        id={id}
        setOpenSectionShip={setOpenSectionShip}
        setOpenSectionPay={setOpenSectionPay}
        setShipList={setShipList}
        setPayList={setPayList}
      /> */}
      {console.log("==", values)}
      <div className="flex justify-between ">
        <div className="flex items-center gap-3">
          <NameIcon />
          <label className="text-[length:var(--address-title-fs)] font-[var(--address-title-fw)]">
            {address.name}
          </label>
        </div>
        {address?.default ? (
          <div className="bg-[var(--address-icon1-fg)] px-2 py-1 rounded-full ">
            <span className="text-[var(--address-default-fg)] text-[length:var(--address-default-fs)] font-[var(--address-default-fw)]">
              Default
            </span>
          </div>
        ) : (
          <ChevronUp className="w-5 h-5 cursor-pointer" onClick={onClose} />
        )}
      </div>
      <div className="flex items-start gap-3">
        <AddressIcon />
        <span className=" text-[length:var(--address-text-fs)] font-[var(--address-text-fw)]">
          {address.address.filter(Boolean).join(", ")}
        </span>
      </div>
    </div>
  );

  const AddressSection = ({
    title,
    icon,
    addresses,
    openSection,
    setOpenSection,
    sectionType, // 'pay' or 'ship'
    bg = "",
  }) => {
    // Create refs for each address item
    const itemRefs = useRef({});

    // Effect to scroll the opened item into view
    // useEffect(() => {
    //   if (openSection && itemRefs.current[openSection]) {
    //     // Use setTimeout to ensure the DOM has updated after state change
    //     setTimeout(() => {
    //       const element = itemRefs.current[openSection];
    //       const container = element.closest(".tab-container");

    //       if (container && element) {
    //         // Calculate the position of the element relative to the container
    //         const containerRect = container.getBoundingClientRect();
    //         const elementRect = element.getBoundingClientRect();

    //         // Scroll only if the element is not fully visible
    //         const isVisible =
    //           elementRect.top >= containerRect.top &&
    //           elementRect.bottom <= containerRect.bottom;

    //         if (!isVisible) {
    //           element.scrollIntoView({
    //             behavior: "smooth",
    //             block: "nearest",
    //             inline: "nearest",
    //           });
    //         }
    //       }
    //     }, 50); // Small delay to ensure DOM update
    //   }
    // }, [openSection]);
    useEffect(() => {
      if (openSection && itemRefs.current[openSection]) {
        setTimeout(() => {
          const element = itemRefs.current[openSection];
          if (!element) return; // Prevents the 'closest' error

          const container = element.closest(".tab-container");
          if (!container) return;

          const containerRect = container.getBoundingClientRect();
          const elementRect = element.getBoundingClientRect();

          const isVisible =
            elementRect.top >= containerRect.top &&
            elementRect.bottom <= containerRect.bottom;

          if (!isVisible) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "nearest",
            });
          }
        }, 50);
      }
    }, [openSection]);

    return (
      <div className="h-full flex flex-col gap-3">
        {/* Section Header */}
        <div className="flex items-center gap-3">
          <div
            className={`rounded-full  ${
              bg == ""
                ? sectionType === "pay"
                  ? "bg-[var(--address-icon1-fg)]"
                  : "bg-[var(--address-icon2-fg)]"
                : bg
            } p-3`}
          >
            {icon}
          </div>
          <label className="text-[length:var(--address-title-fs)] font-[var(--address-title-fw)]">
            {title}
          </label>
        </div>

        {/* Scrollable List */}

        <div className="tab-container flex flex-col gap-3 overflow-y-auto flex-1 min-h-0">
          {addresses.map((item) => {
            const id =
              sectionType === "pay"
                ? item?.cmr_pay_address_id
                : item?.cmr_ship_address_id;
            const name =
              sectionType === "pay"
                ? item?.cmr_pay_address_name
                : item?.cmr_ship_address_name;
            const addressArr =
              sectionType === "pay"
                ? [
                    item?.cmr_pay_address_street,
                    item?.cmr_pay_address_city,
                    item?.cmr_pay_address_district,
                    item?.cmr_pay_address_state,
                    item?.cmr_pay_address_pincode,
                  ]
                : [
                    item?.cmr_ship_address_street,
                    item?.cmr_ship_address_city,
                    item?.cmr_ship_address_district,
                    item?.cmr_ship_address_state,
                    item?.cmr_ship_address_pincode,
                  ];
            const isDefault = item?.cmr_default_address;
            const phone = item?.phone || "";

            return (
              <div
                key={id}
                ref={(el) => {
                  if (el) {
                    itemRefs.current[id] = el;
                  } else {
                    delete itemRefs.current[id];
                  }
                }}
              >
                {/* Collapsed */}
                {openSection !== id && (
                  <div className="border-2 border-[var(--address-close-border-color)] rounded-lg">
                    <div
                      className="p-[10px] rounded-lg cursor-pointer flex items-center justify-between transition-all"
                      onClick={() => {
                        if (block) return;
                        else setOpenSection(id);
                      }}
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                          <NameIcon />
                        </div>
                        <label className="text-[length:var(--address-title-fs)] font-[var(--address-title-fw)]">
                          {name}
                        </label>
                      </div>
                      <ChevronDown className="w-5 h-5" />
                    </div>
                  </div>
                )}
                {console.log("block", block)}
                {/* Expanded */}
                {openSection === id && (
                  <AddressCard
                    address={{
                      name,
                      address: addressArr,
                      default: isDefault,
                    }}
                    onClose={() => {
                      if (block) return;
                      else setOpenSection(null);
                    }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };
  const onSave = () => {
    if (block) return;
    else {
      console.log("888", openSectionShip, openSectionPay);
      console.log(openSectionPay === null, openSectionShip === null);
      if (!openSectionPay || !openSectionShip) {
        errorToast("select pay address and ship address to save");
      } else {
        let payData = payList.find(
          (item, index) => item?.cmr_pay_address_id === openSectionPay
        );
        let shipData = shipList.find(
          (item, index) => item?.cmr_ship_address_id === openSectionShip
        );
        // if (section === "purchase") prefix = "pot";
        // else prefix = "sot";
        if (payData) setFieldValue(`${prefix}_pay_to_address`, payData);
        if (shipData) {
          const address_state=shipData?.cmr_ship_address_state?.toLowerCase() || null;
          const store_state=storeState?.toLowerCase()?.trim();
          if(!address_state){
            errorToast("Please set ship to address state");
            return;
          }
          if(storeState===null || storeState===undefined || storeState?.trim()===""){
            errorToast("Please configure store state in store deatils")
            return;
          }
          setFieldValue(`${prefix}_ship_to_address`, shipData);
          if(store_state===address_state){
            setFieldValue("is_inter_state",false);
          }else{
            setFieldValue("is_inter_state",true);
          }
        }
        successToast("Address is saved");
        setOpen(false);
      }
    }
  };
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
        }}
      >
        {console.log("shipList", shipList)}
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[537px] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl flex flex-col">
                {/* Header */}
                <div className="mb-5 p-4 bg-[var(--address-title-bg)]">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-[var(--address-icon2-fg)] flex items-center justify-center">
                      <AddressTitleIcon />
                    </div>
                    <h2 className="text-[length:var(--address-bold-fs)] font-[var(--address-bold-fw)]">
                      Address Details
                    </h2>
                  </div>
                </div>

                {/* MAIN SCROLLABLE CONTENT */}
                {noAddress ? (
                  <div className="flex-1 min-h-0 flex flex-col items-center gap-6 px-6">
                    <h2 className="text-[length:var(--address-bold-fs)] font-[var(--address-bold-fw)]">
                      No Address
                    </h2>
                  </div>
                ) : (
                  <div className="flex-1 min-h-0 flex flex-col gap-6 px-6">
                    {/* Pay-to Address section, 50% height, scrolls independently */}
                    <div className="h-1/2 min-h-0 flex flex-col">
                      {!invert && (
                        <AddressSection
                          title="Pay-to Address"
                          icon={<PayIcon />}
                          addresses={payList}
                          openSection={openSectionPay}
                          setOpenSection={setOpenSectionPay}
                          sectionType="pay"
                        />
                      )}
                      {invert && (
                        <AddressSection
                          title="Ship-from Address"
                          icon={<ShipIcon />}
                          addresses={shipList}
                          openSection={openSectionShip}
                          setOpenSection={setOpenSectionShip}
                          sectionType="ship"
                        />
                      )}
                    </div>
                    {console.log("...", values)}
                    {/* Ship-to Address section, 50% height, scrolls independently */}
                    {!invert && (
                      <div className="h-1/2 min-h-0 flex flex-col">
                        <AddressSection
                          title="Ship-to Address"
                          icon={<ShipIcon />}
                          addresses={shipList}
                          openSection={openSectionShip}
                          setOpenSection={setOpenSectionShip}
                          sectionType="ship"
                        />
                      </div>
                    )}
                    {invert && (
                      <div className="h-1/2 min-h-0 flex flex-col">
                        <AddressSection
                          title="Ship-to Address"
                          icon={<ShipIcon />}
                          addresses={payList}
                          openSection={openSectionPay}
                          setOpenSection={setOpenSectionPay}
                          sectionType="pay"
                          bg="bg-[var(--address-icon2-fg)]"
                        />
                      </div>
                    )}
                  </div>
                )}

                {/* Footer Buttons */}
                <div className="p-4 mt-auto border-t border-gray-200 bg-white flex justify-between">
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    prefixIcon={false}
                    text={<span>Cancel</span>}
                    className="flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px] bg-[var(--trans-stats-con-red-fg)] cursor-pointer text-white text-[length:var(--draft-button-fs)] font-[var(--draft-button-fw)]"
                    type="button"
                  />
                  {!block && standAlone && (
                    <div className="flex gap-2">
                      <AddButton
                        prefixIcon={true}
                        onclkFn={() => {
                          if (block) return;

                          else {
                            // Get currently selected addresses from local state
                            // If not selected, fall back to existing Formik values
                            let payData = openSectionPay
                              ? payList.find((item) => item?.cmr_pay_address_id === openSectionPay)
                              : values[`${prefix}_pay_to_address`];
                            let shipData = openSectionShip
                              ? shipList.find((item) => item?.cmr_ship_address_id === openSectionShip)
                              : values[`${prefix}_ship_to_address`];
                            // Call autoDraft with the selected addresses included
                            autoDraft({
                              ...values,
                              [`${prefix}_pay_to_address`]: payData || null,
                              [`${prefix}_ship_to_address`]: shipData || null,
                            });
                          }
                        }}
                        text={"Add Address"}
                        className="flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px] bg-[var(--primary-button-bg-color)] cursor-pointer text-[var(--primary-button-fg-color)] border border-[var(--primary-button-bg-color)] hover:bg-[var(--primary-button-hover-color)] text-[length:var(--primary-button-create-fs)] font-[var(--primary-button-font-weight)]"
                        type="button"
                      />
                      {!noAddress && (
                        <AddButton
                          onclkFn={() => {
                            onSave();
                          }}
                          prefixIcon={false}
                          text={<span>Save</span>}
                          className="flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px] bg-[var(--primary-button-bg-color)] cursor-pointer text-[var(--primary-button-fg-color)] border border-[var(--primary-button-bg-color)] hover:bg-[var(--primary-button-hover-color)] text-[length:var(--primary-button-create-fs)] font-[var(--primary-button-font-weight)]"
                          type="button"
                        />
                      )}
                    </div>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
export default AddressSidebarSales;

function FetchAddress({
  //   id,
  setOpenSectionShip,
  setOpenSectionPay,
  setShipList,
  setPayList,
}) {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();
  const onSuccess = (data) => {
    setOpenSectionShip(data?.data?.addressShipping[0].cmr_ship_address_id);
    setOpenSectionPay(data?.data?.addressPay[0].cmr_pay_address_id);

    setShipList(data?.data?.addressShipping || []);
    setPayList(data?.data?.addressPay || []);
  };
  useEffect(() => {
    dispatch(getAddress({cmr_id:values?.cmr_id,pos_id:values?.pos_id}, onSuccess, () => {}));
    return null;
  }, []);
}
